export default {
    apiKey: 'AIzaSyDdhimegLcIrqj2Y1Xm94PP7YlVLzrI31g',
    authDomain: 'collective-vid.firebaseapp.com',
    databaseURL: 'https://collective-vid.firebaseio.com',
    projectId: 'collective-vid',
    storageBucket: 'collective-vid.appspot.com',
}
